import React, { Component, Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Container } from 'reactstrap';
import { connect } from 'react-redux';
import jwtDecode from 'jwt-decode'
import {
  AppBreadcrumb,
  AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarNav,
  AppNavbarBrand,
  AppSidebarToggler
} from '@coreui/react';

import logo from '../../assets/img/brand/logo-bw.svg'
// import sygnet from '../../assets/img/brand/sygnet.svg'

// sidebar nav config
import navigation from '../../_nav';
// routes config
import routes from '../../routes';

import './DefaultLayout.scss';

const DefaultFooter = React.lazy(() => import('./DefaultFooter'));
const DefaultHeader = React.lazy(() => import('./DefaultHeader'));

class DefaultLayout extends Component {

  loading = () => <div className="animated fadeIn pt-1 text-center">Loading...</div>

  isTokenExpired(user) {
    const token = JSON.parse(user)["token"]

    try {
      const decoded = jwtDecode(token);
      if (decoded.exp < Date.now() / 1000) {
        // Checking if token is expired.
        return true;
      } else return false;
    } catch (err) {
      return false;
    }
  }

  signOut(e) {
    e.preventDefault()

    this.props.history.push('/login')
  }

  render() {

    return (
      <>
        <div className="app">
          <div className="app-body">
            <AppSidebar className="sidebar" fixed display="lg">
              <AppSidebarHeader>
                <AppNavbarBrand
                  full={{ src: logo, width: 89, height: 25, alt: 'CoreUI Logo' }}
                // minimized={{ src: sygnet, width: 30, height: 30, alt: 'CoreUI Logo' }}
                />
                <AppSidebarToggler className="d-lg-none toggler" display="md" mobile><i className="iconm-Menu" /></AppSidebarToggler>
                <AppSidebarToggler className="d-md-down-none toggler" display="lg"><i className="iconm-Menu" /></AppSidebarToggler>
              </AppSidebarHeader>
              <AppSidebarForm />
              <Suspense>
                <AppSidebarNav navConfig={navigation} {...this.props} />
              </Suspense>
              <AppSidebarFooter />

            </AppSidebar>
            <main className="main">
              <AppHeader className="navbar" fixed>
                <Suspense fallback={this.loading()}>
                  <DefaultHeader onLogout={e => this.signOut(e)} {...this.props} />
                </Suspense>
              </AppHeader>
              <div className="app-main">
                <AppBreadcrumb appRoutes={routes} />
                <Container fluid>
                  <Suspense fallback={this.loading()}>
                    <Switch>
                      {routes.map((route, idx) => {
                        return route.component ? (
                          <Route
                            key={idx}
                            path={route.path}
                            exact={route.exact}
                            name={route.name}
                            render={props => {
                              
                              if (localStorage.getItem('user') === null || this.isTokenExpired(localStorage.getItem('user'))) {
                                return <Redirect to={{ pathname: "/login" }} />
                              }


                              // const { permission } = this.props.user
                              // const { path } = props.match
                              // const role = path.split("/")


                              // if (permission !== undefined && role[1] in permission) {
                              //   // check read permission
                              //   if (permission[role[1]].indexOf("read") === -1) {
                              //     return <Redirect to={{ pathname: "/500" }} />
                              //   }

                              //   // check update permission
                              //   if (role.indexOf("edit") !== -1 && permission[role[1]].indexOf("update") === -1) {
                              //     return <Redirect to={{ pathname: "/500" }} />
                              //   }

                              //   // check create permission
                              //   if (role.indexOf("create") !== -1 && permission[role[1]].indexOf("create") === -1) {
                              //     return <Redirect to={{ pathname: "/500" }} />
                              //   }
                              // }
                              return <route.component {...props} />

                            }}
                          />
                        ) : (null);
                      })}
                      <Redirect from="/" to="/dashboard" />
                    </Switch>
                  </Suspense>
                </Container>
              </div>
            </main>
          </div>
          <AppFooter>
            <Suspense fallback={this.loading()}>
              <DefaultFooter />
            </Suspense>
          </AppFooter>
        </div>
      </>

    );
  }
}
function mapStateToProps(state) {
  const { authentication } = state;
  const { user } = authentication;
  return {
    user
  };
}

export default connect(mapStateToProps)(DefaultLayout);
